(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "classnames", "@material/react-ripple/dist/index.js"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js")) : factory(root["react"], root["classnames"], root["@material/react-ripple/dist/index.js"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__5__) {
return 